import { Box, Step, StepLabel, Stepper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';
import { tabs, unoTheme, unoThemeStyles } from '../../../../assets/styles/unoTheme';
import { MyTab, MyTabs } from "../../../utils/MyTabs";
import { path } from "../../../utils/routesPaths";
import UnoButton from '../../../utils/UnoButton';
import AccreditedInstitutionsTab from './tabs/AccreditedInstitutionsTab';
import ManualsTab from './tabs/ManualsTab';
import TermsAndAttestationsTab from './tabs/TermsAndAttestationsTab';
import TrademateStatusChip from './tabs/Trademate/TrademateStatusChip';
import TrademateTab, { TRADEMATE_STEPS } from './tabs/Trademate/TrademateTab';
import allActions from '../../../../actions';
import PrintIcon from '@material-ui/icons/Print';
import MySelect from '../../../utils/MySelect';
import { getYearsByYearUntilNow } from '../../../utils/utils';
import { useMemo } from 'react';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: "12px",
    },
    //Stepper do Cadastro Trademate, no slot da direita. O MUI v4 aplica padding 24px no root, que
    //aqui engordaria o header inteiro.
    trademateStepper: {
        padding: '0px',
        background: 'transparent',

        '& .MuiStepLabel-label': {
            fontSize: '12px',
        },
        //O conector do MUI é `flex: 1 1 auto`: ele conta com sobra de espaço no Stepper para
        //esticar. Aqui o Stepper é item de um flex e encolhe até o conteúdo, então não sobra nada
        //e a linha ficava com largura zero. Largura fixa resolve e mantém o header previsível.
        '& .MuiStepConnector-root': {
            flex: '0 0 40px',
        },
        //O StepIcon já troca o número por um check quando a etapa está completed; falta só a cor,
        //que por padrão é a primária. Depende dos nomes de classe internos do MUI v4 — um upgrade
        //de major muda o visual sem gerar erro.
        '& .MuiStepIcon-root.MuiStepIcon-completed': {
            color: unoTheme.successColor,
        },
        '& .MuiStepConnector-completed .MuiStepConnector-line': {
            borderColor: unoTheme.successColor,
        },
    }
});

export const ROOT_ACCREDITATION_DEFAULT_SECTION = 'CLIENTS_ACCREDITATION_ZONE';
export const ACCREDITATION_DEFAULT_SECTION_NAMES = {
    manuals: "Manuais",
    terms: "Modelos de Termos e Atestados",
}

export default function AccreditationScreen(props) {

    const classes = useStyles();
    const unoThemeClasses = unoThemeStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser.user);
    const [tabValue, setTabValue] = useState(0);
    const [checked, setChecked] = useState([]);
    const [currentBreadcrumbOnScreen, setCurrentBreadcrumbOnScreen] = useState("");
    const fileElement = useRef(null);
    const [fileValue, setFileValue] = useState('');
    const [optionsAccreditationProcessesYears,] = useState(
        ['TODOS', ...getYearsByYearUntilNow('2020').reverse()]
    );
    const [selectedAccreditationProcessesYear, setSelectedAccreditationProcessesYear] = useState(0);

    //Passo do wizard do Cadastro Trademate. Mora aqui porque o stepper é renderizado no header, ao
    //lado das abas; toda a lógica de navegação continua dentro do TrademateTab.
    const [trademateStep, setTrademateStep] = useState(0);

    //Ficha do Trademate, espelhada pela aba só para o header desenhar o selo de status. Diferente
    //do passo acima, o dado é buscado lá dentro — aqui é só uma cópia para exibição.
    const [trademateRegistration, setTrademateRegistration] = useState(null);

    const isAdminOrLema = currentUser?.isSuperAdmin;

    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

        // if (newValue == 0) {
        //     history.push(path.administrative.accreditation.documentation)
        // } else
        if (newValue == 0) {
            history.push(path.administrative.accreditation.manuals)
        } else if (newValue == 1) {
            history.push(path.administrative.accreditation.termsAndAttestations)
        } else if (newValue == 2) {
            history.push(path.administrative.accreditation.accreditedInstitutions)
        } else if (newValue == 3) {
            history.push(path.administrative.accreditation.trademate)
        }

    };

    useEffect(() => {
        // Sincronizar tab com a rota atual
        const currentPath = window.location.pathname;
        // if (currentPath.includes('documentation')) {
        //     setTabValue(0);
        // } else 
        if (currentPath.includes('manuals')) {
            setTabValue(0);
        } else if (currentPath.includes('termsAndAttestations')) {
            setTabValue(1);
        } else if (currentPath.includes('accreditedInstitutions')) {
            setTabValue(2);
        } else if (currentPath.includes('trademate')) {
            setTabValue(3);
        }
    }, []);

    const handleDeleteClick = () => {
        // Emitir evento para a aba atual deletar os arquivos
        window.dispatchEvent(new CustomEvent('credenciamentoDelete', { detail: { checked } }));
    };

    const handleCreateFolderClick = () => {
        // Emitir evento para a aba atual criar pasta
        window.dispatchEvent(new CustomEvent('credenciamentoCreateFolder'));
    };

    const handleUploadClick = () => {
        fileElement.current.click();
    };

    const handleUploadFiles = async (e) => {
        window.dispatchEvent(new CustomEvent('credenciamentoUpload', { detail: { files: e.target.files } }));
        setFileValue('');
    };

    const handleDownloadClick = async () => {
        // Emitir evento para a aba atual baixar os arquivos
        window.dispatchEvent(new CustomEvent('credenciamentoDownload', { detail: { checked } }));
    };

    const handleReportAccreditationProcessesClick = () => {
        // Emitir evento para a aba atual deletar os arquivos
        window.dispatchEvent(new CustomEvent('doReportAccreditationProcesses', { detail: { checked } }));
    };

    const handleExcelAccreditationProcessesClick = () => {
        // Emitir evento para a aba atual gerar a planilha
        window.dispatchEvent(new CustomEvent('doExcelAccreditationProcesses'));
    };

    const handleOpenAddAccreditationProcess = () => {
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'newAccreditationProcess',
            data: null,
        }));
    }

    const isRootTermsSection = useMemo(() => {
        return currentBreadcrumbOnScreen.label === ACCREDITATION_DEFAULT_SECTION_NAMES.terms;
    }, [currentBreadcrumbOnScreen])

    return (
        <div className={classes.root}>
            <div className={classes.tabsWithRight}>
                <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>
                    <MyTabs value={tabValue} onChange={handleChangeTabValue}>
                        {/* <MyTab label="Documentação" /> */}
                        <MyTab label="Manuais" />
                        <MyTab label="Termos e Atestados" />
                        <MyTab label="Instituições Credenciadas" />
                        <MyTab label="Cadastro Trademate" />
                    </MyTabs>
                </div>
                {/* Slot da direita, compartilhado pelas abas: filtro e ações nas Instituições
                    Credenciadas, stepper no Cadastro Trademate, botões de arquivo nas demais */}
                {
                    tabValue === 2 && (
                            <Box className={classes.rightHeader}>

                                <MySelect
                                    value={selectedAccreditationProcessesYear}
                                    onChange={(e) => setSelectedAccreditationProcessesYear(e.target.value)}
                                    options={optionsAccreditationProcessesYears.map((row, index) => (
                                        <option key={'accreditation-option-year-' + index} value={index}>
                                            {row}
                                        </option>
                                    ))}

                                />
                                <UnoButton
                                    size={'small'}
                                    type='success'
                                    startIcon={<AddIcon />}
                                    onClick={() => handleOpenAddAccreditationProcess()}>
                                    {"Processo"}
                                </UnoButton>

                                <UnoButton
                                    style={{ marginLeft: "0px" }}
                                    isIconButton
                                    size='small'
                                    type='primary'
                                    myIcon={<PrintIcon />}
                                    onClick={handleReportAccreditationProcessesClick}
                                />

                                <UnoButton
                                    style={{ marginLeft: "0px" }}
                                    isIconButton
                                    size='small'
                                    type='success'
                                    myIcon={<PrintIcon />}
                                    onClick={handleExcelAccreditationProcessesClick}
                                />
                            </Box>
                        )
                }

                {
                    tabValue === 3 && (
                        <Box className={classes.rightHeader}>
                            <TrademateStatusChip registration={trademateRegistration} />
                            <Stepper
                                className={classes.trademateStepper}
                                activeStep={trademateStep}
                                alternativeLabel={false}>
                                {TRADEMATE_STEPS.map((label, index) => (
                                    //`index < trademateStep` basta: o passo só avança depois de a
                                    //ficha existir, então não precisa do stepsUnlocked da aba
                                    <Step key={label} completed={index < trademateStep}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                    )
                }

                {
                    (tabValue === 0 || tabValue === 1) &&
                        <Box className={classes.rightHeader}>
                            {(tabValue === 0 || (
                                tabValue === 1 && !isRootTermsSection
                            )) && (
                                    <>
                                        <UnoButton
                                            isIconButton
                                            size='small'
                                            type='error'
                                            myIcon={<DeleteIcon />}
                                            onClick={handleDeleteClick}
                                        />
                                        <UnoButton
                                            isIconButton
                                            size='small'
                                            type='warning'
                                            myIcon={<CreateNewFolderIcon />}
                                            onClick={handleCreateFolderClick}
                                        />

                                        <UnoButton
                                            isIconButton
                                            size='small'
                                            type='success'
                                            myIcon={<GetAppIcon />}
                                            onClick={handleDownloadClick}
                                        />

                                        <UnoButton
                                            isIconButton
                                            size='small'
                                            type='primary'
                                            myIcon={<PublishIcon />}
                                            onClick={handleUploadClick}
                                        />
                                        <input
                                            type="file"
                                            name="file"
                                            value={fileValue}
                                            onChange={handleUploadFiles}
                                            ref={fileElement}
                                            // multiple
                                            hidden
                                        />
                                    </>
                                )}


                        </Box>
                }
            </div>
            <div className={'defaultScrollWithHeaderContent'}>
                {/* {tabValue === 0 && <DocumentationTab />} */}
                {tabValue === 0 && <ManualsTab />}
                {tabValue === 1 && <TermsAndAttestationsTab isRootTermsSection setCurrentBreadcrumbOnScreen={setCurrentBreadcrumbOnScreen} />}
                {tabValue === 2 && <AccreditedInstitutionsTab selectedYear={optionsAccreditationProcessesYears?.[selectedAccreditationProcessesYear]} />}
                {tabValue === 3 && (
                    <TrademateTab
                        activeStep={trademateStep}
                        setActiveStep={setTrademateStep}
                        /* setter direto, e não arrow inline: uma função nova a cada render
                           entraria na dependência do efeito de sincronia da aba e viraria laço */
                        onRegistrationChange={setTrademateRegistration}
                    />
                )}
            </div>
        </div>
    );
}